import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full py-4 bg-primary-dark bg-opacity-80" }
const _hoisted_2 = { class: "flex w-full p-4 pl-12 text-white border-b" }
const _hoisted_3 = { class: "w-full" }
const _hoisted_4 = { class: "mb-4 text-2xl capitalize" }
const _hoisted_5 = { class: "text-sm font-extralight" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-sm font-thin" }, "Category:", -1)
const _hoisted_7 = { class: "mb-4 text-2xl capitalize" }
const _hoisted_8 = { class: "flex flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_metric_bar = _resolveComponent("metric-bar")
  const _component_fa = _resolveComponent("fa")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.formatPhase(_ctx.phase)), 1),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.percentCompleted) + "% complete ", 1),
        _createVNode(_component_metric_bar, {
          value: _ctx.percentCompleted,
          class: "w-1/2"
        }, null, 8, ["value"])
      ]),
      _createVNode("div", {
        class: "ml-auto text-xl cursor-pointer",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleCloseClick && _ctx.handleCloseClick(...args))),
        "data-testid": "close-button"
      }, " ✕ ")
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.eventCategories, (eventCategory, eventCategoryIndex) => {
      return (_openBlock(), _createBlock("div", {
        class: "p-4 pl-12 border-b",
        key: eventCategoryIndex
      }, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, _toDisplayString(_ctx.formatCategory(eventCategory.category)), 1),
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(eventCategory.events, (eventViewModel, eventIndex) => {
            return (_openBlock(), _createBlock("button", {
              class: ["flex items-center justify-center w-32 p-2 py-1 m-1 text-xs bg-gray-800 border rounded opacity-30 focus:outline-none hover:opacity-100", {
            'opacity-100 border-blue-400':
              eventViewModel.complete || eventViewModel.unlocked,
            'bg-blue-400': eventViewModel.complete
          }],
              onClick: ($event: any) => (_ctx.handleEventNameClick(eventViewModel.eventName)),
              key: eventIndex,
              "data-testid": eventViewModel.eventName
            }, [
              _createTextVNode(_toDisplayString(eventViewModel.eventName) + " ", 1),
              (eventViewModel.complete)
                ? (_openBlock(), _createBlock(_component_fa, {
                    key: 0,
                    icon: "check",
                    type: "fas",
                    class: "pl-1",
                    height: "10"
                  }))
                : (!eventViewModel.unlocked)
                  ? (_openBlock(), _createBlock(_component_fa, {
                      key: 1,
                      icon: "lock",
                      type: "fas",
                      class: "pl-1",
                      height: "10"
                    }))
                  : _createCommentVNode("", true)
            ], 10, ["onClick", "data-testid"]))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}